export const groupBy = <T>(list: T[], getKey: (item: T) => string) =>
  list.reduce((acc, val) => {
    const group = getKey(val);
    if (!acc[group]) acc[group] = [];
    acc[group].push(val);
    return acc;
  }, {} as Record<string, T[]>);
